import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";

// Meta Pixel (Aura Content): registrar una visita una sola vez por carga.
const META_PIXEL_ID = "963992893130442";
type PixelCall = IArguments;
type PixelFn = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue?: PixelCall[];
  push?: (...args: unknown[]) => void;
  loaded?: boolean;
  version?: string;
};
const pixelWindow = window as Window & {
  fbq?: PixelFn;
  _fbq?: PixelFn;
};
if (!pixelWindow.fbq) {
  const fbq = function (...args: unknown[]) {
    if (fbq.callMethod) {
      fbq.callMethod(...args);
    } else {
      fbq.queue!.push(arguments);
    }
  } as PixelFn;
  fbq.queue = [];
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = "2.0";
  pixelWindow.fbq = fbq;
  pixelWindow._fbq = fbq;
  const script = document.createElement("script");
  script.async = true;
  script.src = "https://connect.facebook.net/en_US/fbevents.js";
  document.head.appendChild(script);
  fbq("init", META_PIXEL_ID);
  fbq("track", "PageView");
}
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-334" data-mp="10o2cdit6ei5w" />);
}